<!-- Signup Page Start -->
<div class="register-page-wrap h-auto">
    <div
        class="register-page-inner sm:h-full w-full bg-[url('/assets/images/signup-bg.jpg')] bg-cover bg-center relative">
        <div class="register-page-left md:h-full relative pb-[2em] lg:pt-[2em] lg:pb-[2em] xxl:pb-0">
            <div class="register-content-wrap h-full grid grid-cols-12 items-center">
                <div class="register-content col-span-12 lg:col-span-8 mb-[2em] z-10">
                    <h3 class="primary-title text-white font-bold mb-0 text-[1.4em] md:text-[2.5em] xl:text-[3em]">Book
                        Doctors Appointment<br> Online.</h3>
                    <p class="text-white font-light lg:w-9/12 text-[14px] md:text-[20px] lg:text-xl">
                        Join Medease today and take the first step towards a healthier, more convenient life. Our
                        platform connects you with top medical professionals, allowing you to book appointments
                        effortlessly from the comfort of your home. Sign up now to experience seamless healthcare at
                        your fingertips.
                    </p>
                    <img src="/assets/images/medease-logo-white.png" alt="medease-logo"
                        class="w-[250px] object-contain lg:mt-10">
                </div>
                <div class="register-form-container col-span-12 lg:col-span-4 w-full h-auto z-10">
                    <div class="register-form bg-[#fff] w-full ml-auto rounded-[30px] px-[1.5em] lg:px-[3em] py-[6em] text-center">
                        <img src="/assets/images/medease-logo.png" alt="" class="w-[150px]">
                        <form [formGroup]="registerForm" (ngSubmit)="register()">
                            <div class="input-wrapper mx-auto flex flex-col items-center mt-10">
                                <mat-form-field appearance="fill" color="primary">
                                    <mat-label>Name</mat-label>
                                    <input type="text" matInput formControlName="name">
                                </mat-form-field>
                                <mat-form-field appearance="fill" color="primary">
                                    <mat-label>Email</mat-label>
                                    <input type="email" matInput formControlName="email" #phoneInput>
                                    <div *ngIf="errors.email" class="text-red-800 text-sm">
                                        <div *ngFor="let error of errors.email">{{ error }}</div>
                                    </div>
                                </mat-form-field>
                                <mat-form-field appearance="fill" color="primary">
                                    <mat-label>Phone</mat-label>
                                    <input type="number" matInput formControlName="phone">
                                    <div *ngIf="errors.phone" class="text-red-800 text-sm">
                                        <div *ngFor="let error of errors.phone">{{ error }}</div>
                                    </div>
                                    <div *ngIf="registerForm.get('phone')?.invalid && registerForm.get('phone')?.touched">
                                        <small *ngIf="registerForm.get('phone')?.errors?.['required']">Phone number is required.</small>
                                        <small *ngIf="registerForm.get('phone')?.errors?.['pattern']">Please enter a valid 10-digit number.</small>
                                      </div>
                                </mat-form-field>
                                <mat-form-field appearance="fill" color="primary">
                                    <mat-label>Password</mat-label>
                                    <input type="password" matInput formControlName="password">
                                </mat-form-field>
                                <mat-form-field appearance="fill" color="primary">
                                    <mat-label>Confirm Password</mat-label>
                                    <input type="password" matInput formControlName="confirmPassword">
                                </mat-form-field>
                                <div *ngIf="errors.confirmpassword" class="text-red-800 text-sm">
                                    <div *ngFor="let error of errors.phone">{{ error }}</div>
                                </div>
                                <div
                                    *ngIf="registerForm.get('confirmPassword')?.invalid && registerForm.get('confirmPassword')?.touched" class="text-red-700">
                                    Confirm Password is required.
                                </div>
                                <div
                                    *ngIf="registerForm.errors?.['mismatch'] && registerForm.get('confirmPassword')?.touched">
                                    Passwords must match.
                                </div>
                            </div>
                            <button type="submit" loadingButton
                                class="book-now rounded-[12px] font-bold text-sm px-10 py-4 outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-15 p-2 text-center text-white cursor-pointer mt-10 w-full"
                                [loading]="isLoading" [disabled]="isLoading">
                                Register
                            </button>
                        </form>
                        <div class="mt-10">
                            Already have an account?
                            <a href="/login"
                                class="text-sm text-[#677db9] border-b-[1px] border-[#677db9] bg-transparent p-0">Login</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Signup Page End -->